import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';
import general from '../../../modulos/general';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => { 
  return (
    <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='left aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate?elemento.fechaCreate.substr(0, 10):''}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numOrdenCompra}</td>
      <td className='left aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numSolic}</td>
      <td className='left aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProveed}</td>
      <td className='left aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ciudad}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadAprob?new Intl.NumberFormat('de-DE').format(elemento.cantidadAprob):0}</td>
      <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorPagado?new Intl.NumberFormat('de-DE').format(elemento.valorPagado):0}</td>
   </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const AdminRegPago2 = ({autorizacUA, styles, list, handleClickidLista}) => {
  // const a353001 = autorizacUA.findIndex( autorizac => autorizac === "353001" );
  console.log(list)
return (
  <div>
    <List selection>
      <TitDer list={list} textBoton1="Ordenes de compra recibidas" btnNuevo={"NO"} styles={styles}/>
      
      <div style={{height: '35em', overflow: 'auto'}}>
        <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
          <thead className=''>
            <tr className=''>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Creada</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>No. Orden</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>No. Solicitud</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '30%'}}>Proveedor</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Ciudad</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Pagado</th>
            </tr> 
          </thead>
          <Lista list={list} handleClickidLista={handleClickidLista}/>
        </table>
        <p></p>
      </div>
    </List>

  </div>
)
};

export default AdminRegPago2
